// アプリ全体に関係するイベントを記述する
// 主にApp.vueで呼んでいるメソッド

import store from '@/store'
import { PERSISTED_STATE_KEY } from '@/util/constants'
import moment from 'moment'

/**
 * 子ウィンドウのストア値が変更された時に行う処理
 * 
 * 【詳細説明】
 * 子ウィンドウのストア値の変更は、
 * ローカルストレージに保存し、/store/index.jsのsaveStoragePath変数に設定してローカルストレージに保存するだけでは、
 * 親ウィンドウの同じストア値に同期されない。
 * window.addEventListener('storage')で、ローカルストレージの変更を監視し、
 * 変更された時にこのメソッドは呼ばれるので、
 * このメソッド内でローカルストレージに保存された値を、親ウィンドウのストア値に設定する処理を記述する
 * 
 * @param {*} oldData 
 * @param {*} newData 
 */
const syncronizeLocalStorageValue = (oldData, newData) => {

  // いずれかのブラウザタブでトークン＆フレッシュトークンが更新された場合、他のブラウザタブも同じ値を設定する
  const oldToken = oldData.auth.token
  const newToken = newData.auth.token
  const oldRefreshToken = oldData.auth.refreshToken
  const newRefreshToken = newData.auth.refreshToken
  const oldTokenDate = moment(oldData.auth.lastDate)
  const newTokenDate = moment(newData.auth.lastDate)

  if ((oldToken !== newToken) || (oldRefreshToken !== newRefreshToken)) {
    // tokenのlastDateの方が新しい場合だけtokenを更新
    if (newTokenDate.isAfter(oldTokenDate)) {
      store.dispatch('auth/setToken', {
        token: newToken,
        refreshToken: newRefreshToken
      })
    }
  }

  // // 子ウィンドウである「資料検索」画面のタブの値を、親ウィンドウ側のストアに反映する(同期する)対応
  // // （これにより、再度「資料検索（先例・判例検索）」画面を開いたときに前回と同じタブの選択状態で開くことができる）
  // const oldTab = oldData.precedent.tab ?? 0
  // const newTab = newData.precedent.tab ?? 0
  // if (oldTab !== newTab && oldTab !== 0) {
  //   // タブの値が変化した場合、新しいタブの値をストアに反映する
  //   store.dispatch('precedent/setTab', newTab)
  // }
}

/**
 * ブラウザ（子ウィンドウ）が閉じられたときに行う処理
 * 【用途】
 * 資料検索画面(子ウィンドウ)を閉じたときに、子ウィンドウの設定内容を親ウィンドウにも反映する。
 * @param {*} oldData 
 * @param {*} newData 
 */
const onBrowserWindowClosed = (oldData, newData) => {

  // // 現在の画面名(/router/index.jsのrouter.beforeEach()メソッド内でストアに保存された値)
  // const toName = store.state.common.toName

  // if (toName === 'PCNoteList' || toName === 'SPNoteList') {
  //   // 親ウィンドウが「ノート一覧画面」だった場合、一覧をリロードして最新表示にする
  //   // (資料検索詳細画面の「ノートに保存」で追加したノートを一覧に表示させる)
  //   store.dispatch('note/reset')
  //   store.dispatch('note/getNoteLists')
  //   store.dispatch('note/getNoteCount')
  // }

  // if (toName === 'PCHistoryOfView' || toName === 'SPHistoryOfView') {
  //   // 親ウィンドウが「閲覧履歴画面」だった場合、一覧をリロードして最新表示にする
  //   store.dispatch('browsingHistory/getLists')
  // }

  // if (toName === 'PCHistoryOfSearch' || toName === 'SPHistoryOfSearch') {
  //   // 親ウィンドウが「検索履歴画面」だった場合、一覧をリロードして最新表示にする
  //   store.dispatch('searchHistory/getLists')
  // }

  // if (toName === 'PCSearchConditionList' || toName === 'SPSearchConditionList') {
  //   // 親ウィンドウが「保存検索条件画面」だった場合、一覧をリロードして最新表示にする
  //   store.dispatch('searchCondition/resetListsImmediately')
  //   store.dispatch('searchCondition/getLists')
  // }

  // if (toName === 'PCBookmarkList' || toName === 'SPBookmarkList') {
  //   // 親ウィンドウが「ブックマーク画面」だった場合、一覧をリロードして最新表示にする
  //   store.commit('bookmark/resetState')
  //   store.dispatch('bookmark/getLists')
  // }

  // if (toName === 'PCViewLaterList' || toName === 'SPViewLaterList') {
  //   // 親ウィンドウが「後で見る画面」だった場合、一覧をリロードして最新表示にする
  //   // 現状、資料検索画面に後で見る機能が無いので未対応
  // }
}

/**
 * アプリ全体でイベント監視するためのリスナーを追加する
 */
export const addEventListersForApp = () => {

  // ウィンドウクローズを検知するイベントリスナーを追加
  window.addEventListener('beforeunload', (e) => {
    // アプリが閉じられたことを通知する
    store.dispatch('appEvent/onAppClosed')
  })

  // ローカルストレージの変更を検知するイベントリスナーを追加
  window.addEventListener('storage', (e) => {
    if (e.key === PERSISTED_STATE_KEY) {
      try {
        const oldData = JSON.parse(e.oldValue)
        const newData = JSON.parse(e.newValue)
    
        // 子ウィンドウのストア値の変更を親ウィンドウのストアにも反映する処理
        syncronizeLocalStorageValue(oldData, newData) 

        // クローズカウンタの処理は不要になったので削除。復活する場合はlocalstorageの上書きあいで暴走するので要調整
        // const oldClosedCount = oldData.appEvent.closedCount ?? 0
        // const newClosedCount = newData.appEvent.closedCount ?? 0
        // if (newClosedCount !== 0 && newClosedCount !== oldClosedCount) {
        //   // ブラウザクローズカウンタの値が変わった場合は、ブラウザが閉じられたと判断

        //   // 新しいクローズカウンタの値をストアに設定
        //   store.dispatch('appEvent/setClosedCount', newClosedCount)

        //   // ブラウザ（子ウィンドウ）が閉じられたときに行う処理
        //   onBrowserWindowClosed(oldData, newData)
        // }
      } catch (e) {
      }
    }
  })
}
